import { message } from "antd";
import notificationStyles from "./notification.module.scss";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
} from "@ant-design/icons";
import { NotificationType } from "./Notification.enum";

const DURATION = 3.5;

message.config({
  top: 80,
  maxCount: 3,
  duration: DURATION,
});

/**
 * @param {Object} param0
 * @param {JSX.Element} param0.children
 * @param {string} param0.type
 */
const Notification = ({ children, type = NotificationType.success }) => {
  const getIcon = (toastType) => {
    switch (toastType) {
      case NotificationType.success:
        return <CheckCircleFilled className={notificationStyles.icon} />;
      case NotificationType.error:
        return <CloseCircleFilled className={notificationStyles.icon} />;
      case NotificationType.warn:
        return <ExclamationCircleFilled className={notificationStyles.icon} />;
      case NotificationType.info:
        return <InfoCircleFilled className={notificationStyles.icon} />;
      default:
        throw new Error(`type: "${toastType}" is invalid`);
    }
  };

  const label =
    type === NotificationType.success
      ? "Success"
      : type === NotificationType.error
        ? "Error"
        : type === NotificationType.warn
          ? "Warning"
          : "Info";

  return (
    <div
      className={`${notificationStyles.toast} ${notificationStyles[`toast--${type}`]}`}
    >
      <span className={notificationStyles.accent} aria-hidden="true" />
      <div className={notificationStyles.iconWrap}>{getIcon(type)}</div>
      <div className={notificationStyles.body}>
        <span className={notificationStyles.label}>{label}</span>
        <div className={notificationStyles.message}>{children}</div>
      </div>
      <span className={notificationStyles.shine} aria-hidden="true" />
    </div>
  );
};

/**
 * @param {string | JSX.Element} content
 * @param {number} [duration]
 */
export function showSuccess(content, duration = DURATION) {
  message.destroy();
  message.open({
    content: <Notification>{content}</Notification>,
    duration,
    className: "cb-toast notification-success",
    icon: <span />,
  });
}

/**
 * @param {string | JSX.Element} content
 * @param {number} [duration]
 */
export function showError(content, duration = DURATION) {
  message.destroy();
  message.open({
    content: <Notification type="error">{content}</Notification>,
    duration,
    className: "cb-toast notification-error",
    icon: <span />,
  });
}

/**
 * @param {string | JSX.Element} content
 * @param {number} [duration]
 */
export function showWarn(content, duration = DURATION) {
  message.destroy();
  message.open({
    content: <Notification type="warn">{content}</Notification>,
    duration,
    className: "cb-toast notification-warn",
    icon: <span />,
  });
}

/**
 * @param {string | JSX.Element} content
 * @param {number} [duration]
 */
export function showInfo(content, duration = DURATION) {
  message.open({
    content: <Notification type="info">{content}</Notification>,
    duration,
    className: "cb-toast notification-info",
    icon: <span />,
  });
}
